'use strict';

import { guuid } from '@aretheyhappy/utils';

export default {
    data() {
        return {
            uid: guuid(),
            ui_window_w: window.innerWidth,
        };
    },
    methods: {
        onUIMobileWindowSizeChanged: function () {
            this.ui_window_w = window.innerWidth;
        },
    },
    computed: {
        UIMobile: function () {
            return this.ui_window_w < 1024;
        },
        UIMobileSmall: function () {
            return this.ui_window_w < 769;
        }
    },
    created() {
        MeadCommon.GlobalListeners.bind();
        MeadCommon.Flash.subscribe(this.uid, MeadCommon.GLOBAL_EVENT_TYPES.WINDOW_RESIZE, this.onUIMobileWindowSizeChanged);
    },
    destroyed() {
        MeadCommon.Flash.unsubscribe(this.uid);
    },
};
